<template>
  <article class="theme dark">
    <div v-if="$route.meta.isPopup">
      <router-view> </router-view>
    </div>
    <div v-else-if="$route.path !== '/capture'">
      <!-- 무료플랜 레퍼럴 등록 안내 || 미등록으로 이용불가 팝업 -->
      <RefGuide v-if="risingUserInfo" />
      <!-- 코인 미선택시 팝업-->
      <notAuth v-if="risingUserInfo"/>

      <!-- 캡쳐 페이지 아닐때는 알람창 있어야됨 -->
      <PageLayout>
        <router-view></router-view>
        <!-- <AlertMsg v-show="alertMsg.visible"/> -->
        <div class="bg-blur" v-show="alertMsg.visible"></div>
      </PageLayout>
    </div>
    <div v-else-if="$route.path == '/capture'">
      <!--  캡쳐는 로그인안해도 페이지 들어갈수있어야해서 알림창 없앰 -->
      <router-view></router-view>
    </div>
  </article>
</template>
<script setup>
// import AlertMsg from "./components/bot/AlertMsg.vue";
import RefGuide from "./components/common/modal/RefGuide.vue";
import notAuth from "./components/common/modal/notAuth.vue";
import PageLayout from "@/views/defaultLayout.vue";
import "@/assets/scss/components/ui/titleDialog.scss";
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();
import { getCookie, getRisingUserInfo } from "@/api/authToken";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { ref, computed, onMounted, watchEffect } from "vue";
import { axiosInstance, risingInstance, risingAPI } from "@/api/baseApi";

const router = useRouter();
const route = useRoute();
const store = useStore();
const alertMsg = computed(() => store.state.usePopupList.alertMsg);
const currentEnv = process.env.NODE_ENV;
const risingUserInfo = computed(() => store.state.userInfo.risingUserInfo);
// console.log("currentEnv", currentEnv);
// 라우터 인스턴스의 beforeEach 훅을 설정
const RID_AUT = ref("");
router.beforeEach(async (to, from, next) => {
  // console.log("to", to.path, "from", from.path);
  // if(to.path != from.path){
  try {
    // if (currentEnv != "development"){
    // if(to.path == '/kibot/bot') {
    //   await chkSession();
    // }else if(to.path == '/kibot/chart' || to.path == '/kibot/chart2'){
    //   await isLoginned();
    // }
    if (to.path !== "/capture") {
      await isLoginned(to.path);
    }
    // }
    next();
  } catch {
    // location.href = 'https://www.risingx.io/login'
    next(false); // 또는 원하는 다른 경로로 이동하도록 설정
  }
  // }
});

const isLoginned = async (path) => {
  try {
    let result = await getRisingUserInfo();
    // console.log('is loggined',result.data);
    if (!result.error) {
      await store.dispatch("userInfo/getChartSubscribeInfo", result.data);
      await store.dispatch("useMainMenuList/updateMenuSubItems");
      const user = computed(() => store.state.userInfo.risingUserInfo);

      const user_info = {
        login: result.data ? true : false,
        user_no: user.value.user_no,
        email: user.value.user_email,
        chart: {
          end_dt: user.value.chart.subsc_end_dt,
          product: user.value.chart.subsc_type,
          start_dt: user.value.chart.subsc_start_dt,
          status: user.value.chart.subsc_status,
        },
      };

      store.commit("userInfo/setUserInfo", user_info);

      axiosInstance.defaults.headers["SECRET-KEY"] = process.env.VUE_APP_BOT_SECRET

      // let result = await getCookie();

      // console.log('risingUserInfo',risingUserInfo.value,'result.data.auto',result.data.auto);
      // if (path == "/kibot/bot") {
      //   if (result.data.auto != null) {
      //     let result = await getCookie();
      //     console.log("result", result);
      //     if (!result.user.login) {
      //       // console.log('not loggined');
      //     } else {
      //       store.commit("userInfo/setUserInfo", result.user);
      //       store.commit("userInfo/setBotInfo", result.bot);
      //     }
      //   }
      // }
    } else {
      // console.log("not loggined");
    }
  } catch (error) {
    await store.dispatch("userInfo/getChartSubscribeInfo", []);
    // console.log("not loggined");
  }
};
// const chkSession = async () => {
//   try {
//     // console.log('checkSession');

//     // let result = await getCookie();
//     // console.log('result', result);
//     if (!result.user.login) {
//       // openAlertMsg(422);
//       // console.log('not login');
//       // location.href = 'https://www.risingx.co.kr/login'
//     } else {
//       store.commit("userInfo/setUserInfo", result.user);
//       store.commit("userInfo/setBotInfo", result.bot);
//     }
//   } catch (error) {
//     // openAlertMsg(422);
//     // console.log("error");
//     // location.href = 'https://www.risingx.io/login'
//   }
// };

onMounted(() => {
  // setInterval(()=> {
  //   RID_AUT.value = cookies.get('RID_AUT');
  // },10000)

  // 페이지 처음 접속시에만 레퍼럴 등록 안내 팝업 활성화
  if (performance.navigation.type === performance.navigation.TYPE_NAVIGATE) {
    store.dispatch("usePopupList/setRefPopup", true);
  } 
  
  store.dispatch("useGlobalList/initializeLocale");
});

// watchEffect(async()=> {
//   console.log('RID_AUT',RID_AUT.value);
//   if(!RID_AUT.value){
//     await isLoginned(route.path)
//   }
// })
</script>

<style lang="scss" scoped>
.bg-blur {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: #00000045;
  backdrop-filter: blur(20px);
  z-index: 3;
}
</style>
